import { z } from 'zod';

export const idArray = z.array(z.number().int());

export const transactionDateOrder = z.object({
	dateOrder: z.literal('transactionDate'),
	transactionStartDate: z.iso.date(),
	transactionEndDate: z.iso.date().optional(),
	applicationStartDate: z.iso.date().optional(),
	applicationEndDate: z.iso.date().optional(),
});

export const applicationDateOrder = z.object({
	dateOrder: z.literal('applicationDate'),
	applicationStartDate: z.iso.date(),
	applicationEndDate: z.iso.date().optional(),
	transactionStartDate: z.iso.date().optional(),
	transactionEndDate: z.iso.date().optional(),
});

export const paymentReportsFilterSchema = z.discriminatedUnion('type', [
	z.object({
		type: z.literal('accountId'),
		value: z.number().int(),
	}),
	z.object({
		type: z.literal('subscriptionName'),
		value: z.string(),
	}),
]);
